import React, { useEffect, useState } from "react";

import { useTranslation } from "next-i18next";

import { cn } from "@/common/utils/css.utils";

import { analyticsService } from "@/common/services/analytics/analytics.service";
import ShareIcon from "@whoppah/icons/24/Share";

type ProductDetailsShareButtonProps = {
  transparent?: boolean;
};

export const ProductDetailsShareButton = ({
  transparent = true,
}: ProductDetailsShareButtonProps) => {
  const { t } = useTranslation();

  // The navigator.share is not supported by all of the browsers yet. If it's not supported we are not showing the share button.
  const [canShare, setCanShare] = useState(false);

  useEffect(() => {
    if (navigator?.canShare?.({ url: window.location.href })) {
      setCanShare(true);
    }
  }, []);

  const handleShareClick = () => {
    analyticsService.trackShare();
    navigator.share({ url: window.location.href });
  };

  /**
   * preventing layout shift with a dummy div
   */
  if (!canShare) {
    return <div className="h-9 w-9"></div>;
  }

  return (
    <button
      aria-label={t("pdp:pdp-share-this-deal")}
      onClick={handleShareClick}
      className={cn(
        "flex h-9 w-9 cursor-pointer items-center justify-center rounded-full shadow-[0_2px_4px_rgba(0,0,0,0.1)]",
        !transparent && "bg-white",
        transparent && "border-[1px] text-grey-700 hover:bg-grey-700/[0.1]"
      )}
    >
      <ShareIcon className="text-grey-700" />
    </button>
  );
};
